export default "__VITE_ASSET__93ef0bc6__"